export const personButtonE2eClass = 'person-button';
